import React from 'react';

function SomethingWentWrong() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh'
      }}
    >
      <h1>Something went wrong</h1>
    </div>
  );
}

export default SomethingWentWrong;
